import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as userActions from './reducer';

import './CurrentUser.css';

export class CurrentUserComponent extends Component {
  static get propTypes() {
    return {
      user: PropTypes.shape({
        Name: PropTypes.string.isRequired
      }),
      fetchCurrentUser: PropTypes.func.isRequired
    };
  }

  constructor(props) {
    super(props);
    this.props.fetchCurrentUser();
  }

  render() {
    const { user } = this.props;

    return (<div className="CurrentUser">
      {user &&
        <span className="CurrentUser-name">{user.Name}</span>
      }
      { (user && user.CanAdminister) &&
        <NavLink
          to="/admin"
          className="CurrentUser-admin"
        >Admin</NavLink>
      }
    </div>);
  }
}

const mapStateToProps = state => ({
  user: state.user.current
});

const mapDispatchToProps = (dispatch) => {
  const {
    fetchCurrentUserIfNeeded
  } = bindActionCreators(userActions, dispatch);

  return {
    fetchCurrentUser: fetchCurrentUserIfNeeded
  };
};

const CurrentUser = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(CurrentUserComponent));
export default CurrentUser;



// WEBPACK FOOTER //
// ./src/user/CurrentUser.js